<template>
  <v-card outlined class="rounded-lg overflow-hidden preview-card">
    <div class="preview-toolbar d-flex align-center px-4 py-2">
      <v-icon color="white" small class="mr-2">mdi-earth</v-icon>
      <div class="text-body-2 white--text font-weight-medium preview-url">{{ iframeUrl || 'No domain configured yet' }}</div>
      <v-spacer></v-spacer>
      <v-btn small icon dark @click="reload" :disabled="!iframeUrl">
        <v-icon small>mdi-refresh</v-icon>
      </v-btn>
    </div>

    <iframe
      v-if="iframeUrl"
      :src="iframeUrl"
      ref="previewFrame"
      :key="reloadKey"
      width="100%"
      height="600"
      style="border: none; display: block;"
    ></iframe>
    <div v-else class="text-center pa-10 grey--text">
      <v-icon size="48" color="grey lighten-1">mdi-web-off</v-icon>
      <div class="mt-2">Set up your website domain to preview it here</div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    domain: String,        // e.g., schoolusername.mysite.com or custom domain
    path: {
      type: String,
      default: '/'
    }
  },
  data() {
    return {
      reloadKey: Date.now()
    };
  },
  computed: {
    iframeUrl() {
      if (!this.domain) return null;
      return `https://${this.domain}${this.path}`;
    }
  },
  methods: {
    reload() {
      this.reloadKey = Date.now();
    }
  }
};
</script>

<style scoped>
.preview-card {
    border: 1px solid #ECEFF7;
}
.preview-toolbar {
    background: linear-gradient(135deg, #1E3C72 0%, #2A5298 100%);
}
.preview-url {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
